import React from 'react'
import Router from 'next/router'
import * as Sentry from '@sentry/node'
import styled from 'styled-components'

import { assetPrefix } from 'config/env_config'
import { Area } from '../components/styled'
import Button from '../components/button'
import { PAGE_URL } from 'utils'

const ErrorArea = styled(Area)`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: var(--primary-font);
  padding: 1rem 2.5rem;
`

const Title = styled.div`
  font-size: 3rem;
  font-weight: bold;
  text-align: center;
`
const Subtitle = styled.div`
  font-size: 1.6rem;
  margin-bottom: 2rem;
`
export const ImageBox = styled.div`
  margin-bottom: 2rem;
  background-color: var(--the-white);
  border-radius: 50%;

  img {
    width: 20rem;
  }
`

class Error extends React.Component {
  static async getInitialProps ({ res, err }) {
    const statusCode = res
      ? res.statusCode
      : err && err.response && err.response.status
        ? err.response.status
        : err && err.statusCode
          ? err.statusCode
          : 404
    const errorInitialProps = {
      hasGetInitialPropsRun: true,
      statusCode
    }

    // Não grava o erro se for uma request 404
    if (statusCode === 404) {
      return { statusCode: 404 }
    }
    if (err) {
      Sentry.captureException(err)
    }
    await Sentry.flush(2000)
    return errorInitialProps
  }

  is400Error = () => {
    return this.props.statusCode >= 400 && this.props.statusCode < 500
  }

  getErrorMessage = () => {
    if (this.is400Error()) {
      return 'Não conseguimos encontrar o que você estava procurando.'
    }
    return 'Um erro inesperado ocorreu e estamos trabalhando para consertar o problema'
  }

  handleGoToHomepage = () => {
    Router.push(PAGE_URL.SCHEDULING_INDEX)
  }

  render () {
    const { hasGetInitialPropsRun, err } = this.props
    if (!hasGetInitialPropsRun && err) {
      Sentry.captureException(err)
    }

    return (
      <ErrorArea>
        <Title>
          Oops!
        </Title>
        <ImageBox>
          <img src={`${assetPrefix}/static/images/page-not-found.svg`} />
        </ImageBox>
        <Subtitle>
          {this.getErrorMessage()}
        </Subtitle>
        {this.is400Error() && (
          <Button
            color='var(--cobasi-blue)'
            fontColor='var(--the-white)'
            border='var(--cobasi-blue)'
            label='Ir para a página inicial'
            onClick={this.handleGoToHomepage}
          />
        )}
      </ErrorArea>
    )
  }
}

export default Error
